/* @flow */
import * as React from "react";
import SetpointPicker from "./SetpointPicker";
import { IconPivotOccupied, IconPivotUnoccupied } from "../../Icons";
import ValueCallout from "./ValueCallout";
import prefixStyles from "../../utils/prefixStyles";
import UserLanguageContext from "../../ContextWrappers/UserLanguageContext";

type Props = {
  selectedSetpoint?: "heat" | "cool" | null,
  mode?: string,
  occupancyMode?: string,
  handleShowHeat: () => void,
  handleShowCool: () => void,
  handleHeatUp: () => void,
  handleHeatDown: () => void,
  handleCoolUp: () => void,
  handleCoolDown: () => void,
  setpointHeat?: number,
  setpointCool?: number,
  setpointIncrement: number,
  pickerValue: number,
  setpointMin: number,
  setpointMax: number,
};

type OccupancyProps = {
  occupancyMode?: ?string,
};

class OccupancyIcon extends React.Component<OccupancyProps> {
  render() {
    const styles = {
      icon: {
        fontSize: "2.5em",
      },
    };

    const { occupancyMode } = this.props;
    if (occupancyMode) {
      if (occupancyMode.toLowerCase() === "occupied") {
        return <IconPivotOccupied style={styles.icon} />;
      } else {
        return <IconPivotUnoccupied style={styles.icon} />;
      }
    }
    return null;
  }
}

export default class TileControl extends React.Component<Props> {
  constructCallouts() {
    const styles = {
      content: prefixStyles({
        display: "flex",
        justifyContent: "space-around",
        alignItems: "space-around",
      }),
    };

    const { mode, occupancyMode } = this.props;
    return (
      <div style={styles.content}>
        {mode ? this.getCallout(mode) : null}
        <OccupancyIcon occupancyMode={occupancyMode} />
        {mode === "auto" ? this.getCallout("cool") : null}
      </div>
    );
  }

  getCallout(mode: string) {
    const {
      setpointHeat,
      setpointCool,
      handleShowHeat,
      handleShowCool,
    } = this.props;

    const languageContext = this.context;
    const language = languageContext.localeSet.nx_components.TileControl;

    const isHeatOrAuto = mode === "heat" || mode === "auto";

    const kind = isHeatOrAuto ? "heat" : "cool";
    const label = isHeatOrAuto ? language.Heat : language.Cool;
    const callback = isHeatOrAuto ? handleShowHeat : handleShowCool;
    const setpoint = isHeatOrAuto ? setpointHeat : setpointCool;

    return (
      <ValueCallout
        key={kind}
        label={label}
        kind={kind}
        value={setpoint}
        onTap={callback}
      />
    );
  }

  constructPicker() {
    const {
      selectedSetpoint,
      pickerValue,
      handleHeatUp,
      handleHeatDown,
      handleCoolUp,
      handleCoolDown,
      setpointIncrement,
      setpointMax,
      setpointMin,
    } = this.props;

    const isHeating = selectedSetpoint === "heat";

    return (
      <SetpointPicker
        value={pickerValue}
        kind={selectedSetpoint || "heat"} // Default value keeps Flow happy
        onUp={isHeating ? handleHeatUp : handleCoolUp}
        onDown={isHeating ? handleHeatDown : handleCoolDown}
        upDisabled={pickerValue + setpointIncrement > setpointMax}
        downDisabled={pickerValue - setpointIncrement < setpointMin}
      />
    );
  }
  render() {
    const { selectedSetpoint } = this.props;
    return selectedSetpoint ? this.constructPicker() : this.constructCallouts();
  }
}

TileControl.contextType = UserLanguageContext;



// WEBPACK FOOTER //
// ../nx-components/src/Thermostat/TileControls/TileControl.jsx